import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useStopwatch } from 'react-timer-hook';

const MyStopwatch = ({finished}) => {
  const {
          seconds,
          minutes,
          pause
        } = useStopwatch({autoStart: true, format: '12-hour'});

  useEffect(() => {
    if (finished == true) {
      pause();
    }
    return () => {};
  }, [finished]);

  const addZeroLeft = (number) => {
    if (number > 9) {
      return <span>{number}</span>;
    } else {
      return <span>0{number}</span>;
    }
  };

  return (
    <span className={classNames('badge', {
      'bg-success text-white animate__animated animate__heartBeat animate__infinite': (finished == true),
      'bg-light text-muted':                                                          (finished == false)
    })}>
      <i className='fas fa-stopwatch' />
      <span> - </span>
      <span>{addZeroLeft(minutes)}:{addZeroLeft(seconds)}</span>
    </span>
  );
};

const CardBaseProcessamentoSo = ({numeroProcesso, tag, children, finished}) => {
  let tagText = 'AÇÃO';
  switch (tag) {
    case 'new_folder_processo_so':
      tagText = 'CRIAÇÃO';
      break;
    case 'update_folder_processo_so':
      tagText = 'ATUALIZAÇÃO';
      break;
    case 'em_processamento':
      tagText = 'EM PROCESSAMENTO';
      break;
  }

  return (
    <>
      <div className='d-flex justify-content-center pt-5 animate__animated animate__zoomIn '>
        <div className='col-8 mt-5'>
          <div className='card mt-5'>
            <div className='card-header text-center bg-primary text-white py-1'>
              <small className='my-0'>PROCESSO Nº:</small>
              <h3 className='my-0'>{numeroProcesso}</h3>
              <small>
                <span className='badge bg-light text-muted'>{tagText}</span> | <MyStopwatch finished={finished} />
              </small>
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(CardBaseProcessamentoSo);
